module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-container', {
    staticClass: "filter-requirements-input",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    attrs: {
      "align-h": "start"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "query",
      "placeholder": "Filter requirements"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n          Hide/show columns\n          "), _c('icon', {
    staticClass: "when-opened",
    attrs: {
      "name": "chevron-up"
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "when-closed",
    attrs: {
      "name": "chevron-down"
    }
  })], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkboxes1",
      "name": "flavour1",
      "options": _vm.issueTypeColumnOptions
    },
    model: {
      value: (_vm.selectedIssueTypeColumns),
      callback: function($$v) {
        _vm.selectedIssueTypeColumns = $$v
      },
      expression: "selectedIssueTypeColumns"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "id": "dropdown-1"
    }
  }, [_c('template', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "name": _vm.loading ? 'spinner' : 'download',
      "pulse": _vm.loading
    }
  }), _vm._v(" Export\n          ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.generateDocx()
      }
    }
  }, [_vm._v("Word (.docx)")])], 2)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('h7', [_vm._v("Generating your export...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.progressValue,
      "variant": "success",
      "animated": ""
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('traceability-matrix-grid', {
    attrs: {
      "searchQuery": _vm.searchQuery,
      "selectedIssueTypeColumns": _vm.selectedIssueTypeColumns
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0c0e542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TraceabilityMatrixView.vue
// module id = 1025
// module chunks = 1